let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1qwir")).then(() => parcelRequire('9TuK8'));